import { __extends } from "tslib";
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
var DatePickerIcon = (function (_super) {
    __extends(DatePickerIcon, _super);
    function DatePickerIcon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DatePickerIcon.prototype.render = function () {
        return (React.createElement("div", { className: 'rb-datepicker-icon', onClick: this.props.onClick },
            React.createElement("i", null,
                React.createElement(FontAwesomeIcon, { icon: faCalendarAlt }))));
    };
    return DatePickerIcon;
}(React.PureComponent));
export { DatePickerIcon };
